// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"2f39ec50","124":"288f44a5","150":"c51b7c97","685":"a7642242","778":"52089398","956":"8aecf11e"}[chunkId] + ".chunk.js";
};